import { ChangeDetectorRef, ElementRef, inject, DOCUMENT } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, filter, fromEvent, merge, Observable, of, switchMap, tap } from 'rxjs';

export function rxHostListener<T extends Event>(event: string, inWindow = false): Observable<T> {
  const cdr = inject(ChangeDetectorRef);

  const el = inWindow ? inject(DOCUMENT).defaultView : inject(ElementRef).nativeElement;

  return fromEvent<T>(el, event).pipe(
    debounceTime(0),
    tap(() => cdr.markForCheck()), // Trigger CD like @HostListener would
    takeUntilDestroyed()
  );
}

export function rxHostPressedListener() {
  return merge(
    rxHostListener('click'),
    rxHostListener<KeyboardEvent>('keyup').pipe(
      switchMap(x => {
        return x.code === 'Space' || x.code === 'Enter' ? of(true) : of(null);
      }),
      filter(Boolean)
    )
  ).pipe(debounceTime(0));
}
